import React from "react";
import { withRouter } from "react-router";
import AxiosConfig from "axiosConfig";
import "components/Project/Home/ActiveProjectHomeInfo/ActiveProjectInfo.css";
import Image from "react-bootstrap/Image";
import TextTheme from "components/General/Text/TextTheme";
import ProgressStepper from "components/Project/ProgressStepper";
import Button from "react-bootstrap/Button";
import "components/Project/Home/ActiveProjectHomeInfo/ActiveProjectInfo.css";

class EachActiveProject extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.projectSlug,
      projectBadge: this.props.badge,
      projectName: "",
      projectJoinDate: "",
    };
  }

  componentDidMount() {
    const projectSlug = this.props.projectSlug;
    AxiosConfig.get(`/impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectName: res.data["name"],
          projectBanner: res.data["banner"],
        });
      })
      .catch();
  }

  renderDate(date, type) {
    let msg;
    if (date !== null && type === "Planning") {
      msg = "Started On ";
      return <p className="dateShown">{msg + date}</p>;
    } else if (date !== null && type === "Active") {
      msg = "Joined On ";
      return <p className="dateShown">{msg + this.formatDate(date)}</p>;
    } else if (date !== null && type === "Invitation") {
      msg = "By " + this.props.inviterName + " on ";
      date = this.formatDate(date);
      return <p className="dateShown">{msg + date}</p>;
    } else {
      msg = "Date not available";
      return <p className="dateShown">{msg}</p>;
    }
  }

  renderProgressStepper(status, type) {
    let isInvite = true;
    if (this.props.inviterEmail === "" || this.props.inviterEmail === null) {
      isInvite = false;
    }
    if (type === "Planning") {
      if ("PlanningStarted" === status) {
        return (
          <div className="stepperWidth">
            <ProgressStepper currentStep="0" />
          </div>
        );
      } else if ("PlanningPhase1" === status) {
        return (
          <div className="stepperWidth">
            <ProgressStepper currentStep="1" />
          </div>
        );
      } else if ("PlanningPhase2" === status) {
        return (
          <div className="stepperWidth">
            <ProgressStepper currentStep="2" />
          </div>
        );
      }
    } else {
      if (status === "PlanningStarted") {
        return (
          <div className="stepperWidth">
            <ProgressStepper
              className="stepperWidth"
              currentStep="1"
              isInvite={isInvite}
              showStepper={true}
            />
          </div>
        );
      }
      if (status === "PlanningPhase1") {
        return (
          <div className="stepperWidth">
            <ProgressStepper
              className="stepperWidth"
              currentStep="2"
              isInvite={isInvite}
              showStepper={true}
            />
          </div>
        );
      }
      if (status === "PlanningPhase3") {
        return (
          <div className="stepperWidth">
            <ProgressStepper
              className="stepperWidth"
              currentStep="3"
              isInvite={isInvite}
              showStepper={true}
            />
          </div>
        );
      }
      if (status === "StartChallenge" || status === "Challenge3Complete") {
        return (
          <div className="stepperWidth">
            <ProgressStepper
              className="stepperWidth"
              currentStep="4"
              isInvite={isInvite}
              showStepper={true}
            />
          </div>
        );
      } else {
        return (
          <div className="stepperWidth">
            <ProgressStepper currentStep="0" showStepper={true} />
          </div>
        );
      }
    }
  }
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  }
  handleProjectClick() {
    let isInvite = true;
    if (this.props.inviterEmail === "" || this.props.inviterEmail === null) {
      isInvite = false;
    }
    if (this.props.type === "Planning") {
      if ("PlanningStarted" === this.props.projectStatus) {
        window.location.assign(
          "/projects/" + this.state.projectSlug + "/start-project-step-one"
        );
      } else if ("PlanningPhase1" === this.props.projectStatus) {
        window.location.assign(
          "/projects/" + this.state.projectSlug + "/start-project-step-two"
        );
      } else if ("PlanningPhase2" === this.props.projectStatus) {
        window.location.assign(
          "/projects/" + this.state.projectSlug + "/start-project-step-three"
        );
      } else {
        window.location.assign("/projects/" + this.state.projectSlug);
      }
    } else if (this.props.type === "Active") {
      const {
        projectStatus,
        projectSlug,
        challenge,
        goalDate,
        inviterEmail,
        invitationId,
        projectUserId,
      } = this.props;
      let nextUrl = "";
      let adSlug = "";
      let showStepperFlag = false;
      let goal_Date = new Date();
      goal_Date.setTime(
        new Date(goalDate).getTime() +
          new Date(goalDate).getTimezoneOffset() * 60 * 1000
      );
      if (challenge.adventure.slug === "SPREAD_THE_WORD") {
        adSlug = "/spread-the-word";
      } else if (challenge.adventure.slug === "LEARN_NEW_SKILL") {
        adSlug = "/learn-new-skill";
      } else if (challenge.adventure.slug === "DEVELOP_NEW_HABIT") {
        adSlug = "/develop-new-habit";
      } else if (challenge.adventure.slug === "VOLUNTEER") {
        adSlug = "/volunteer-time";
      } else if (challenge.adventure.slug === "GIVE_A_DONATION") {
        adSlug = "/give-a-donation";
      } else if (challenge.adventure.slug === "RAISE_FUNDS") {
        adSlug = "/fundraise";
      } else if (challenge.adventure.slug === "RAISE_YOUR_VOICE") {
        adSlug = "/raise-your-voice";
      }
      if (projectStatus === "PlanningPhase1" && isInvite === true) {
        nextUrl = "/projects/" + projectSlug + adSlug;
        showStepperFlag = true;
      } else if (projectStatus === "PlanningStarted") {
        nextUrl = `/projects/${projectSlug}/start-project-step-one`;
        showStepperFlag = true;
      } else if (projectStatus === "PlanningPhase1") {
        nextUrl = `/projects/${projectSlug}/start-project-step-two`;
        showStepperFlag = true;
      } else if (projectStatus === "PlanningPhase3") {
        nextUrl = `/projects/${projectSlug}/start-project-step-three`;
        showStepperFlag = true;
      } else if (
        (this.props.inviterEmail !== "" || this.props.inviterEmail !== null) &&
        (projectStatus === "StartChallenge" ||
          projectStatus === "Challenge3Complete")
      ) {
        nextUrl = "/projects/" + projectSlug + adSlug;
        showStepperFlag = false;
      } else if (
        projectStatus === "StartChallenge" ||
        projectStatus === "Challenge3Complete"
      ) {
        nextUrl = "/projects/" + projectSlug + adSlug;
        showStepperFlag = false;
      }
      this.props.history.push({
        pathname: nextUrl,
        state: {
          challengeSlug: challenge.slug,
          adventureId: challenge.adventure.id,
          adventureSlug: challenge.adventure.slug,
          goalDate: goal_Date,
          projectSlug: projectSlug,
          email: inviterEmail,
          invitationId: invitationId,
          isInvite: isInvite,
          projectUserId: projectUserId,
          showStepper: showStepperFlag,
        },
      });
    } else if (this.props.type === "Invitation") {
      this.buttonHandler();
    }
  }

  buttonHandler() {
    const { projectSlug, inviterEmail, invitationId, challenge } = this.props;
    this.props.history.push({
      pathname: `/projects/${projectSlug}/project-invitation/${inviterEmail}`,
      state: {
        challengeSlug: challenge.slug,
        adventureId: challenge.adventure.id,
        adventureSlug: challenge.adventure.slug,
        email: inviterEmail,
        invitationId: invitationId,
        showStepper: true,
      },
    });
  }

  renderProgressStepperOrButton(type) {
    if (type === "Invitation") {
      return (
        <Button
          className="viewButton"
          onClick={this.buttonHandler.bind(this)}
          size="md"
        >
          View Invitation
        </Button>
      );
    } else {
      return (
        // this is for planning or Active
        <div>
          {this.renderProgressStepper(
            this.props.projectStatus,
            this.props.type
          )}
        </div>
      );
    }
  }

  render() {
    return (
      <div class="aSingleProject" onClick={() => this.handleProjectClick()}>
        <div className="ActiveProjectInfo_Badge">
          {this.props.type === "Active" ? (
            <Image src={this.props.challenge.image} roundedCircle />
          ) : (
            <Image src={this.state.projectBadge} roundedCircle />
          )}
        </div>
        <div className="ActiveProjectInfo_Text">
          <div class="project-invite-details">
            <div className="projectName">
              {this.props.type === "Active" ? (
                <TextTheme
                  message={this.props.challenge.name}
                  className="text_medium text_dark_blue text_semi_bold"
                />
              ) : (
                <TextTheme
                  message={this.state.projectName}
                  className="text_medium text_dark_blue text_semi_bold"
                />
              )}
            </div>
            {this.renderDate(this.props.projectDate, this.props.type)}
          </div>
          <div className="stepperspace">
            {this.renderProgressStepperOrButton(this.props.type)}
          </div>
        </div>
      </div>
    );
  }
}
EachActiveProject = withRouter(EachActiveProject);
export default EachActiveProject;
